(function () {
'use strict';
if (window.__nestMrcFeeCartLineResync20260709 === 'v4-loader-gated-region-map') return;
window.__nestMrcFeeCartLineResync20260709 = 'v4-loader-gated-region-map';
var feeProductIds = { 6543483142225: 1 };
var feeUnitFallbackCents = 1800;
var timer = null;
var running = false;
var pending = false;
var rawFetch = window.fetch ? window.fetch.bind(window) : null;
var cartRootSelector = '.cart-modal,#CartDrawer,.cart-drawer,.drawer--cart,.ajax-cart,.ajaxcart,[data-cart-drawer],[data-cart-container],form[action*="/cart"]';
var controlSelector = 'button,a,input,select,textarea,[role="button"],[data-cart-remove],[href*="/cart/change"],[name="updates[]"],[data-quantity-input],[class*="qty" i],[class*="quantity" i]';
function textOf(item) {
return [item && item.product_title, item && item.title, item && item.handle, item && item.url, item && item.product_type, item && item.vendor].join(' ').toLowerCase();
}
function propsOf(item) {
return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
}
function detectedRegion() {
try {
if (typeof window.geotargetly_region_code === 'function') return String(window.geotargetly_region_code() || '').trim().toUpperCase();
} catch (error) {}
return '';
}
function centsFromValue(value) {
var raw = String(value || '').replace(/[^0-9.]/g, '');
var num = Number(raw);
if (!isFinite(num) || num <= 0) return feeUnitFallbackCents;
return raw.indexOf('.') > -1 ? Math.round(num * 100) : Math.round(num);
}
function loaderMap(region) {
var map = {};
var feeVariants = {};
var loaders = document.querySelectorAll('.recycling-fee-product-loader[data-product][data-region][data-mrc]');
Array.prototype.forEach.call(loaders, function (node) {
var nodeRegion = String(node.getAttribute('data-region') || '').trim().toUpperCase();
var productId = String(node.getAttribute('data-product') || '').trim();
var feeVariantId = Number(node.getAttribute('data-mrc') || 0);
var feeCents = centsFromValue(node.getAttribute('data-recycling-fee-value'));
if (!region || nodeRegion !== region || !productId || !feeVariantId) return;
map[productId] = { productId: productId, region: nodeRegion, feeVariantId: feeVariantId, feeCents: feeCents };
feeVariants[feeVariantId] = 1;
});
return { region: region, byProduct: map, feeVariants: feeVariants, loaderCount: loaders.length };
}
function isMrcFee(item, map) {
var props = propsOf(item);
var text = textOf(item);
var variantId = Number(item && item.variant_id);
return !!(map && map.feeVariants && map.feeVariants[variantId]) ||
!!feeProductIds[Number(item && item.product_id)] ||
String(props.type || '').toLowerCase() === 'fee' ||
text.indexOf('mrc recycling fee') > -1 ||
text.indexOf('mattress recycling fee') > -1 ||
text.indexOf('recycling fee') > -1;
}
function feeItems(cart, map) {
return (cart && cart.items || []).filter(function (item) { return isMrcFee(item, map); });
}
function feeQty(cart, map) {
return feeItems(cart, map).reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0);
}
function feeCents(cart, map) {
return feeItems(cart, map).reduce(function (sum, item) { return sum + Number(item.final_line_price || 0); }, 0);
}
function expectedGroups(cart, map) {
var groups = {};
(cart && cart.items || []).forEach(function (item) {
var productId = String(item && item.product_id || '');
var match = map && map.byProduct && map.byProduct[productId];
var quantity = Number(item && item.quantity || 0);
if (!match || quantity <= 0 || isMrcFee(item, map)) return;
if (!groups[match.feeVariantId]) {
groups[match.feeVariantId] = { variantId: match.feeVariantId, quantity: 0, feeCents: match.feeCents, region: match.region, productIds: [] };
}
groups[match.feeVariantId].quantity += quantity;
groups[match.feeVariantId].productIds.push(productId);
});
return groups;
}
function totalExpectedQty(groups) {
return Object.keys(groups || {}).reduce(function (sum, key) { return sum + Number(groups[key].quantity || 0); }, 0);
}
function desiredNote(cart, map) {
var groups = expectedGroups(cart, map);
var keys = Object.keys(groups);
var feeTotal = 0;
if (!keys.length) return '';
keys.forEach(function (key) {
feeTotal += Number(groups[key].quantity || 0) * Number(groups[key].feeCents || feeUnitFallbackCents);
});
if (feeTotal <= 0) return '';
return 'Recycling Fee: $' + (Number(groups[keys[0]].feeCents || feeUnitFallbackCents) / 100).toFixed(2) + ' | MRC:111110-' + Math.round(feeTotal / 100) + '-' + (map.region || '');
}
function emitAmountRefresh(reason, result) {
var detail = Object.assign({ reason: reason || 'sync', at: Date.now() }, result || {});
window.__nestMrcFeeCartLineResyncLastEvent = detail;
try { window.dispatchEvent(new CustomEvent('nest:mrc-fee-line-resynced', { detail: detail })); } catch (error) {}
try { document.dispatchEvent(new CustomEvent('nest:mrc-fee-line-resynced', { detail: detail })); } catch (error) {}
}
function fetchCart(reason) {
if (!rawFetch) return Promise.reject(new Error('fetch unavailable'));
return rawFetch('/cart.js?mrc_raw=1&mrc_line_resync=1&t=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
.then(function (response) { if (!response.ok) throw new Error('cart read failed: ' + response.status); return response.json(); })
.then(function (cart) {
var map = loaderMap(detectedRegion());
var groups = expectedGroups(cart, map);
window.__nestMrcFeeCartLineResyncLastRead = {
at: Date.now(),
reason: reason || 'read',
region: map.region,
loaderCount: map.loaderCount,
mappedProductCount: Object.keys(map.byProduct).length,
expectedQty: totalExpectedQty(groups),
expectedGroups: groups,
mrcLineCount: feeItems(cart, map).length,
mrcQuantity: feeQty(cart, map),
mrcTotalCents: feeCents(cart, map)
};
return cart;
});
}
function changeLine(id, quantity) {
return rawFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' }, credentials: 'same-origin', body: 'id=' + encodeURIComponent(id) + '&quantity=' + encodeURIComponent(quantity) })
.then(function (response) { if (!response.ok) throw new Error('fee line change failed: ' + response.status); return response.json(); });
}
function addFee(variantId, quantity) {
return rawFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' }, credentials: 'same-origin', body: 'id=' + encodeURIComponent(variantId) + '&quantity=' + encodeURIComponent(quantity) + '&properties%5Btype%5D=fee' })
.then(function (response) { if (!response.ok) throw new Error('fee line add failed: ' + response.status); return response.json(); });
}
function updateNote(cart, map) {
var note = desiredNote(cart, map);
var current = String(cart && cart.note || '');
if (!note && current && !/MRC:|Recycling Fee/i.test(current)) return Promise.resolve(cart);
if (current === note) return Promise.resolve(cart);
return rawFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' }, credentials: 'same-origin', body: 'note=' + encodeURIComponent(note) })
.then(function (response) { if (!response.ok) throw new Error('fee note update failed: ' + response.status); return response.json(); });
}
function sync(reason) {
if (!rawFetch) return;
if (running) { pending = true; return; }
running = true;
pending = false;
fetchCart(reason).then(function (cart) {
var map = loaderMap(detectedRegion());
var groups = expectedGroups(cart, map);
var fees = feeItems(cart, map);
var actions = [];
var expected = totalExpectedQty(groups);
var feeByVariant = {};
fees.forEach(function (item) {
var variantId = Number(item.variant_id);
if (!feeByVariant[variantId]) feeByVariant[variantId] = [];
feeByVariant[variantId].push(item);
});
window.__nestMrcFeeCartLineResyncLastState = {
at: Date.now(),
reason: reason || 'sync',
region: map.region,
loaderCount: map.loaderCount,
mappedProductCount: Object.keys(map.byProduct).length,
expectedQty: expected,
expectedGroups: groups,
mrcLineCount: fees.length,
mrcQuantity: feeQty(cart, map),
mrcTotalCents: feeCents(cart, map)
};
Object.keys(groups).forEach(function (variantId) {
var group = groups[variantId];
var lines = feeByVariant[variantId] || [];
if (!lines.length) {
actions.push(addFee(variantId, group.quantity));
} else {
lines.forEach(function (item, index) {
if (index === 0 && Number(item.quantity || 0) === group.quantity) return;
actions.push(changeLine(item.key || item.variant_id, index === 0 ? group.quantity : 0));
});
}
});
fees.forEach(function (item) {
if (!groups[Number(item.variant_id)]) actions.push(changeLine(item.key || item.variant_id, 0));
});
if (!actions.length) {
return updateNote(cart, map).then(function () { return { changed: false, expected: expected, current: feeQty(cart, map), lines: fees.length, cents: feeCents(cart, map), region: map.region }; });
}
return Promise.all(actions).then(function () { return fetchCart('after ' + (reason || 'sync')); }).then(function (nextCart) {
var nextMap = loaderMap(detectedRegion());
return updateNote(nextCart, nextMap).then(function () { return { changed: true, expected: expected, before: feeQty(cart, map), after: feeQty(nextCart, nextMap), lines: feeItems(nextCart, nextMap).length, cents: feeCents(nextCart, nextMap), region: nextMap.region }; });
});
}).then(function (result) {
window.__nestMrcFeeCartLineResyncLastApply = Object.assign({ at: Date.now(), reason: reason || 'sync' }, result || {});
emitAmountRefresh(reason, result);
}).catch(function (error) {
window.__nestMrcFeeCartLineResyncLastError = error && error.message ? error.message : String(error);
}).finally(function () {
running = false;
if (pending) schedule('pending', 80);
});
}
function schedule(reason, delay) {
window.clearTimeout(timer);
timer = window.setTimeout(function () { sync(reason); }, typeof delay === 'number' ? delay : 180);
}
function scheduleSeries(reason) {
schedule(reason, 60);
[320, 900, 1800].forEach(function (delay) { window.setTimeout(function () { sync(reason + ' +' + delay); }, delay); });
}
function cartControl(target) { return target && target.closest && target.closest(cartRootSelector) && target.closest(controlSelector); }
function patchFetch() {
if (!window.fetch || window.fetch.__nestMrcFeeCartLineResync20260710LoaderGated) return;
rawFetch = window.fetch.bind(window);
window.fetch = function () {
var input = arguments[0];
var url = typeof input === 'string' ? input : input && input.url;
return rawFetch.apply(this, arguments).then(function (response) {
if (/\/cart\/(add|change|update)(?:\.js)?(?:\?|$)/.test(String(url || '')) && !/mrc_line_resync=1/.test(String(url || ''))) scheduleSeries('after fetch ' + url);
return response;
});
};
window.fetch.__nestMrcFeeCartLineResync20260710LoaderGated = true;
}
function bind() {
patchFetch();
scheduleSeries('initial');
document.addEventListener('click', function (event) { if (cartControl(event.target)) scheduleSeries('cart click'); }, true);
document.addEventListener('change', function (event) { if (cartControl(event.target)) scheduleSeries('cart change'); }, true);
document.addEventListener('input', function (event) { if (cartControl(event.target)) scheduleSeries('cart input'); }, true);
['refreshAjaxCart', 'refreshCart', 'cart:refresh'].forEach(function (eventName) {
document.addEventListener(eventName, function () { scheduleSeries(eventName); }, true);
window.addEventListener(eventName, function () { scheduleSeries(eventName); }, true);
});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
else bind();
})();
